export class Constants {
    static avkBlue = "#002395";
    static selectedColor = "#f28900";
    static cavitationChartDangerColor = "rgba(255,0,0,0.25)";
    static chartFontFamily = "'Neue Helvetica W02', 'Helvetica', 'Arial', sans-serif";
    static opAreaMin = 10;
    static opAreaMax = 80;
    static capChartBorderColor = "#FFF";
    static capChartTextColor = "#000";
    static capChartOpAreaColor = "grey";
    static invisible = "rgba(0,0,0,0)";

    static REDUCED = 0;
    static FULL = 1;

    static defaultFlow = 0;
    static defaultInletPressure = 0;
    static defaultOutletPressure = 0;
    static defaultValveDimension = 200;
    static defaultValveBore = Constants.REDUCED;
    static defaultDescription = "";
    static defaultLocation = 0;
    static capChartPointRadius = 12;
    static capChartPointBorderWidth = 4;
    static capChartRatio = [1, 1];
    static cavChartRatio = [3, 2];
    static cavChartPointRadius = 6;
    static cavChartPointBorderWidth = 2;

    static pointVisibleProps = {
        color: Constants.avkBlue,
        borderColor: Constants.capChartBorderColor,
        textColor: Constants.capChartTextColor,
        radius: Constants.capChartPointRadius,
        borderWidth: Constants.capChartPointBorderWidth
    };
    static pointInvisibleProps = {
        color: Constants.invisible,
        borderColor: Constants.invisible,
        textColor: Constants.invisible,
        radius: 0,
        borderWidth: 0
    };
    static pointSelectedProps = {
        color: Constants.selectedColor,
        borderColor: Constants.capChartBorderColor,
        textColor: Constants.capChartTextColor,
        radius: Constants.capChartPointRadius,
        borderWidth: Constants.capChartPointBorderWidth
    };
}